import {useContext, useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import ConditionalRender from "components/ConditionalRender";
import MapPoligonManager from "components/maps/MapPoligonManager";
import AuthContext from "context/AuthContext";

//import {useTranslation} from "react-i18next";
//import useCustomTranslation from "core/customTranslation";
//import ConditionalRender from "components/ConditionalRender";
// const translations = {
//     es: {
//         "warning.description": "Se debe de seleccionar una zona.",
//     },
//     en: {
//         "warning.description": "You must select a zone.",
//     },
//};

const ZoneModel = {
    id: "",
    name: "",
    polylines: [],
};

const TabData = ({item, params, _Tf}) => {
    //const {t: _Tf} = useCustomTranslation(translations);
    const {panel} = useContext(AuthContext);
    const [zone, setZone] = useState({...ZoneModel});
    useEffect(() => {
        if (item.id && item.zone_data.polylines.length) {
            setZone(item.zone_data);
        }
    }, [item]);

    const onChangeZone = (e) => {
        const zone_ = params.current.zones.find((zone) => zone.id === parseInt(e.target.value));
        if (zone_) {
            setZone(zone_);
        }
    };

    return (
        <>
            <div className="col-12 px-5">
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="uuid" className="col-form-label">
                            {_Tf("common.name")}
                        </label>
                    </div>
                    <div className="col-9">
                        <input type="text" className="form-control" id="name" name="name" defaultValue={item.name} required />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="description" className="col-form-label">
                            {_Tf("common.description")}
                        </label>
                    </div>
                    <div className="col-9">
                        <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            rows="3"
                            defaultValue={item.description}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="description" className="col-form-label">
                            {_Tf("labels.driver")}
                        </label>
                    </div>
                    <div className="col-9">
                        <Form.Select aria-label={_Tf("labels.driver")} name="driver" defaultValue={item.email}>
                            <option value="">{_Tf("labels.select")}</option>
                            {params.current.drivers.map((email, idx) => (
                                <option value={email} key={idx}>
                                    {email}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="description" className="col-form-label">
                            {_Tf("labels.initial")}
                        </label>
                    </div>
                    <div className="col-9">
                        <Form.Select aria-label={_Tf("labels.driver")} name="waypoint_id" defaultValue={item.waypoint_id}>
                            <option value="">{_Tf("labels.select")}</option>
                            {params.current.waypoints.map((way, idx) => (
                                <option value={way.id} key={idx}>
                                    {way.name}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3">
                        <label htmlFor="description" className="col-form-label">
                            {_Tf("labels.zone")}
                        </label>
                    </div>
                    <div className="col-9">
                        <Form.Select
                            aria-label={_Tf("labels.zone")}
                            name="zone"
                            defaultValue={item.zone_id}
                            onChange={onChangeZone}
                            required>
                            <option value="">{_Tf("labels.select")}</option>
                            {params.current.zones.map((zone, idx) => (
                                <option value={zone.id} key={idx}>
                                    {zone.name}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>
                <ConditionalRender condition={zone.id}>
                    <div className="row g-3 align-items-center mt-3">
                        <div className="col-12">
                            <MapPoligonManager id="zone-map" center={panel.coords} zone={zone} />
                        </div>
                    </div>
                </ConditionalRender>
            </div>
        </>
    );
};

export default TabData;
